export default {
    SET_SELECT_TREASURER(state,Treasurer){
        state.selectTreasurer = Treasurer
    },
    SET_RESULT(state,result){
        state.Result = result
    },
    SET_EDIT_TREASURER(state,editTreasurer){
        state.editTreasurer = editTreasurer
    },
}